export const rating_fields = [
  {
    name: 'overall',
    label: 'Yleisarvio',
    svg:
      '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 16 15"><g fill="none" fill-rule="evenodd"><path fill="#353C43" fill-rule="nonzero" d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"/><path d="M-2-2.5h20v20H-2z"/></g></svg>',
  },
  {
    name: 'näkemyksellinen',
    label: 'Näkemyksellinen',
    svg:
      '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" class="h-5 w-5" viewBox="0 0 20 20" fill="#353C43"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" /></svg>',
  },
  {
    name: 'vahva_arkkitehtuuri',
    label: 'Vahva arkkitehtuuri',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" width="15" height="15" fill="#353C43"><path fill-rule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clip-rule="evenodd" /></svg>`,
  },
  {
    name: 'uusi_ja_vanha_käsi_kädessä',
    label: 'Uusi ja vanha käsi kädessä',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="-5 -5 805 805"><g
    id="YinYang"
    fill="#353C43"
    stroke="none"
    stroke-width="0"
    fill-rule="evenodd"
  >
    <path d="M400 0C179.086 0 0 179.086 0 400 0 620.914 179.086 800 400 800 620.914 800 800 620.914 800 400 800 179.086 620.914 0 400 0zM400 10C184.609 10 10 184.609 10 400 10 615.391 184.609 790 400 790 292.304 790 205 682.304 205 600 205 492.3 292.304 400 400 400 507.7 400 600 292.304 600 200 600 92.304 507.7 10 400 10zM400 665c35.895 0 65-29.105 65-65 0-35.895-29.105-65-65-65-35.895 0-65 29.105-65 65 0 35.895 29.105 65 65 65zM400 132c-37.555 0-68 30.445-68 68 0 37.555 30.445 68 68 68 37.555 0 68-30.445 68-68 0-37.555-30.445-68-68-68z" />
  </g></svg>`,
  },
  {
    name: 'toimiva_liityntäpysäköinti',
    label: 'Toimiva liityntäpysäköinti',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 512 512"><g>
    <path
      d="M256,0C114.837,0,0,114.837,0,256s114.837,256,256,256s256-114.837,256-256S397.163,0,256,0z M277.333,277.333h-42.667
v128c0,11.776-9.536,21.333-21.333,21.333c-11.797,0-21.333-9.557-21.333-21.333V256V128c0-11.776,9.536-21.333,21.333-21.333h64
c47.061,0,85.333,38.272,85.333,85.333S324.395,277.333,277.333,277.333z"
    />
    <path d="M277.333,149.333h-42.667v85.333h42.667C300.864,234.667,320,215.531,320,192S300.864,149.333,277.333,149.333z" />
  </g></svg>`,
  },
  {
    name: 'laadukas_kävely_ympäristö',
    label: 'Laadukas kävely-ympäristö',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 59.351 59.351"><g>
    <path
      fill="#353C43"
      d="M16.113,51.517c-0.918,1.566-0.868,3.498,0.705,4.66c1.346,0.992,3.742,0.863,4.662-0.704
c1.902-3.244,5.351-5.687,5.351-5.687s-1.27-2.798-1.871-8.041C24.959,41.746,18.277,47.824,16.113,51.517z"
    />
    <path
      fill="#353C43"
      d="M43.244,23.299c-3.903-3.474-8.09-6.591-12.672-9.098c-0.493-0.373-1.057-0.665-1.652-0.86
c-0.398-0.161-0.789-0.239-1.165-0.25c-0.629-0.072-1.259-0.04-1.836,0.115c-1.523,0.408-2.551,1.34-3.136,2.526
c-2.823,3.297-5.181,6.88-7.297,10.666c-2.101,3.756,3.657,7.117,5.756,3.364c0.656-1.175,1.332-2.333,2.038-3.469
c0.609,4.104,1.217,8.208,1.824,12.311c0.123,0.832,0.519,1.548,1.072,2.13c0.884,5.842,2.507,11.605,5.066,16.907
c1.867,3.87,7.614,0.487,5.756-3.365c-1.912-3.961-3.19-8.346-3.977-12.769c1.73-1.205,2.357-3.375,2.033-5.569
c-0.602-4.052-1.201-8.106-1.803-12.159c1.822,1.315,3.58,2.725,5.275,4.234C41.733,30.858,46.464,26.161,43.244,23.299z"
    />
    <circle fill="#353C43" cx="27.254" cy="5.808" r="5.808" />
  </g></svg>`,
  },
  {
    name: 'sujuvat_pyöräily_olosuhteet',
    label: 'Sujuvat pyöräily-olosuhteet',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 462.56 462.56"><g id="XMLID_52_">
    <circle id="XMLID_59_" cx="238.999" cy="44.777" r="35.378"/>
    <path id="XMLID_53_" d="M368.286,264.622c-6.14,0-12.142,0.597-17.958,1.723l-18.757-55.736l12.898,6.449
      c6.171,3.087,13.683,0.585,16.771-5.59c3.087-6.175,0.584-13.683-5.591-16.771l-35.147-17.573
      c4.77,7.085,6.722,16.043,4.675,25.028c-2.114,9.277-8.058,16.684-15.781,20.945l3.553,10.557l-39.437,1.163
      c0.344,4.236-0.095,8.536-1.337,12.699l-3.717,12.461l22.444-0.662l-31.422,30.757l-13.103,43.925
      c-2.688-0.879-5.688-0.859-8.52,0.275l-8.669,3.468c0.037-0.115,0.083-0.224,0.117-0.341l28.125-94.281
      c2.874-9.632-2.154-19.853-11.538-23.455l-17.31-6.645c-4.93-1.123-7.776-1.772-10.763-2.453
      c-9.037-2.059-15.384-9.668-16.307-18.398l-6.489-62.315l21.476,56.632c1.903,5.019,6.192,8.751,11.425,9.944l62.437,14.229
      c8.639,1.966,17.224-3.442,19.189-12.066c1.967-8.631-3.436-17.222-12.066-19.19l-54.059-12.319l-18.428-48.596l19.331,27.011
      l5.476-14.342c4.708-12.331-1.471-26.143-13.802-30.851l-39.815-15.202c-12.331-4.708-26.143,1.471-30.851,13.802
      c-31.455,82.38-30.172,78.204-31.124,83.678c-1.729,9.945,0.306,19.964,5.308,28.298c-20.879,0-14.791,0-17.02,0
      c-8.284,0-15,6.716-15,15s6.716,15,15,15h24.773l2.541,6.128l-17.523,25.631c-11.635-5.148-24.497-8.015-38.017-8.015
      C42.291,264.622,0,306.914,0,358.896c0,51.982,42.291,94.273,94.274,94.273c45.794,0,84.06-32.823,92.524-76.177
      c1.752,0.898,3.705,1.389,5.706,1.389c1.545,0,3.116-0.289,4.639-0.897l50-20c6.409-2.564,9.527-9.838,6.964-16.249
      c-1.034-2.586-2.843-4.624-5.045-5.982l73.777-72.215l3.802,11.297c-31.152,15.405-52.629,47.519-52.629,84.56
      c0,51.982,42.291,94.273,94.275,94.273c51.982,0,94.273-42.291,94.273-94.273C462.56,306.914,420.269,264.622,368.286,264.622z
       M139.457,306.452c11.732,10.122,20.038,24.096,22.939,39.944h-50.248L139.457,306.452z M94.274,428.17
      C56.076,428.17,25,397.094,25,358.896c0-38.198,31.076-69.274,69.274-69.274c8.275,0,16.213,1.463,23.576,4.137l-39.71,58.083
      c-2.617,3.827-2.9,8.788-0.736,12.888c2.164,4.1,6.419,6.667,11.055,6.667h73.936C156.492,403.645,128.203,428.17,94.274,428.17z
       M187.857,354.272c-0.834,0.333-1.608,0.75-2.325,1.23c-8.051-8.674-11.493-21.238-7.835-33.499l1.312-4.399
      c-6.064-12.394-14.768-23.268-25.376-31.889l7.614-11.137l17.796,42.914l9.059-30.367l-10.15-24.477l17.607-0.52l1.097-3.678
      c-8.8-3.378-36.877-14.156-45.777-17.573c46.212,0,41.303,0.02,42.437-0.041l22.159,8.356l-23.032,77.209
      c-2.64,8.851,1.398,18.1,9.187,22.361L187.857,354.272z M368.286,428.17c-38.198,0-69.275-31.076-69.275-69.273
      c0-26.023,14.431-48.73,35.703-60.568l21.725,64.555c1.757,5.221,6.625,8.517,11.845,8.517c1.322,0,2.667-0.211,3.989-0.656
      c6.543-2.202,10.061-9.291,7.859-15.834l-21.73-64.571c3.23-0.464,6.527-0.717,9.883-0.717c38.197,0,69.273,31.076,69.273,69.274
      C437.56,397.094,406.483,428.17,368.286,428.17z"/>
  </g></svg>`,
  },
  {
    name: 'oivalliset_toiminnalliset_ideat',
    label: 'Oivalliset toiminnalliset ideat',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 260.771 260.771"><g>
    <path d="m172.489,50.811c-22.048-14.561-49.42-16.623-75.095-5.66-16.099,6.874-28.84,19.31-35.877,35.019-7.332,16.367-9.425,33.665-6.054,50.025 3.154,15.306 10.844,29.117 22.237,39.941 10.603,10.073 16.685,24.489 16.685,39.551v15.49c0,4.275 1.916,8.259 5.257,10.93l11.411,9.118c0.476,0.38 0.749,0.947 0.749,1.555 0,7.714 6.276,13.99 13.99,13.99h9.187c7.714,0 13.99-6.276 13.99-13.99 0-0.608 0.272-1.175 0.747-1.555l11.413-9.119c3.34-2.67 5.256-6.654 5.256-10.929v-15.494c0-14.952 6.188-29.469 16.979-39.829 15.166-14.561 23.518-34.153 23.518-55.168-2.84217e-14-25.774-12.858-49.654-34.393-63.875zm-35.52,195.969c0,1.098-0.893,1.99-1.99,1.99h-9.187c-1.097,0-1.99-0.893-1.99-1.99 0-4.275-1.916-8.259-5.257-10.93l-11.411-9.118c-0.476-0.38-0.749-0.947-0.749-1.555v-9.679h48v9.679c0,0.608-0.273,1.175-0.748,1.555l-11.413,9.119c-3.34,2.67-5.255,6.653-5.255,10.929zm17.719-43.281h-48.599c-1.472-16.059-8.615-31.129-20.123-42.063-20.641-19.609-25.813-48.868-13.498-76.36 5.799-12.945 16.325-23.205 29.638-28.889 9.354-3.994 18.951-5.974 28.33-5.974 12.582,0 24.77,3.564 35.44,10.611 18.163,11.994 29.006,32.129 29.006,53.863 0,17.717-7.042,34.235-19.829,46.512-11.639,11.175-18.867,26.327-20.365,42.3z"/>
    <path d="m130.385,29.333c3.313,0 6-2.687 6-6v-17.333c0-3.313-2.687-6-6-6s-6,2.687-6,6v17.333c1.42109e-14,3.314 2.687,6 6,6z"/>
    <path d="m202.996,33.591l-12.256,12.257c-2.343,2.343-2.343,6.142 0,8.485 1.172,1.171 2.707,1.757 4.243,1.757s3.071-0.586 4.243-1.757l12.256-12.257c2.343-2.343 2.343-6.142 0-8.485-2.344-2.343-6.143-2.343-8.486,0z"/>
    <path d="m239.073,108.688h-17.333c-3.313,0-6,2.687-6,6s2.687,6 6,6h17.333c3.313,0 6-2.687 6-6s-2.687-6-6-6z"/>
    <path d="m199.225,175.042c-2.343-2.343-6.143-2.343-8.485,0-2.343,2.343-2.343,6.142 0,8.485l12.256,12.256c1.171,1.171 2.707,1.757 4.243,1.757s3.071-0.586 4.243-1.757c2.343-2.343 2.343-6.142 0-8.485l-12.257-12.256z"/>
    <path d="m61.545,175.042l-12.256,12.256c-2.343,2.343-2.343,6.142 0,8.485 1.171,1.171 2.707,1.757 4.243,1.757s3.071-0.586 4.243-1.757l12.256-12.256c2.343-2.343 2.343-6.142 0-8.485-2.343-2.343-6.143-2.343-8.486-2.84217e-14z"/>
    <path d="m39.031,108.688h-17.333c-3.313,0-6,2.687-6,6s2.687,6 6,6h17.333c3.313,0 6-2.687 6-6s-2.686-6-6-6z"/>
    <path d="m61.545,54.333c1.172,1.171 2.707,1.757 4.243,1.757 1.535,0 3.071-0.586 4.243-1.757 2.343-2.343 2.343-6.142 0-8.485l-12.257-12.257c-2.343-2.343-6.142-2.343-8.485,0-2.343,2.343-2.343,6.142 0,8.485l12.256,12.257z"/>
    <path d="m129.774,74.409c-5.523,0.338-9.726,5.088-9.389,10.611l4,65.449c0.179,2.991 2.567,5.446 5.633,5.633 3.314,0.203 6.164-2.32 6.367-5.633l4-65.449c0.021-0.384 0.024-0.83 0-1.222-0.337-5.522-5.088-9.726-10.611-9.389z"/>
    <circle cx="130.385" cy="175.187" r="7"/>
  </g></svg>`,
  },
  {
    name: 'hyvät_kestävän_kehityksen_ratkaisut',
    label: 'Hyvät kestävän kehityksen ratkaisut',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 16 16"><path fill="#444" d="M8 3.1l1.4 2.2-1.6 1.1 1.3 0.3 2.8 0.6 0.6-2.7 0.4-1.4-1.8 1.1-2-3.3h-2.2l-2.6 4.3 1.7 1z"></path>
    <path fill="#444" d="M16 12l-2.7-4.3-1.7 1 2 3.3h-2.6v-2l-3 3 3 3v-2h3.7z"></path>
    <path fill="#444" d="M2.4 12v0l1.4-2.3 1.7 1.1-0.9-4.2-2.8 0.7-1.3 0.3 1.6 1-2.1 3.4 1.3 2h5.7v-2z"></path></svg>`,
  },
  {
    name: 'monipuoliset_asumisen_ratkaisut',
    label: 'Monipuoliset asumisen ratkaisut',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20"><svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
  </svg></svg>`,
  },
  {
    name: 'hieno_viherympäristö',
    label: 'Hieno viherympäristö',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 297 297"><g>
    <path d="M144.865,162.638v11.946c0,4.11-2.164,8.014-5.817,9.897c-4.225,2.178-9.266,1.358-12.574-1.948l-7.817-7.819l-7.352,7.352
      l18.259,18.258c2.034,2.035,3.155,4.74,3.155,7.618v79.593c0,5.226,4.237,9.463,9.463,9.463h15.763
      c5.226,0,9.463-4.237,9.463-9.463V219.91c0-2.878,1.12-5.583,3.155-7.618l15.133-15.133l-7.352-7.352l-4.691,4.692
      c-3.307,3.303-8.339,4.122-12.565,1.953c-3.657-1.877-5.826-5.779-5.826-9.889l0-23.925H144.865z"/>
    <path d="M289.432,122.216c0-34.74-26.947-63.303-61.037-65.881C216.498,22.81,184.664,0,148.5,0S80.502,22.81,68.605,56.336
      c-34.09,2.578-61.037,31.141-61.037,65.881c0,17.725,7.026,34.476,19.469,46.838c-0.501,3.078-0.753,6.191-0.753,9.307
      c0,32.009,26.041,58.05,58.049,58.05h34.491v-27.176l-19.552-19.551c-2.034-2.033-3.156-4.739-3.156-7.618
      c0-2.879,1.121-5.585,3.158-7.619l11.765-11.766c4.201-4.199,11.035-4.199,15.236,0l4.695,4.696v-7.861
      c0-5.94,4.833-10.773,10.773-10.773h16.641c5.94,0,10.773,4.832,10.773,10.773v19.828l1.569-1.57
      c2.034-2.034,4.74-3.155,7.617-3.155c2.878-0.001,5.584,1.12,7.619,3.155l11.766,11.766c0,0,0,0,0.001,0
      c4.2,4.201,4.2,11.036,0,15.236l-16.426,16.426v15.209h31.365c32.008,0,58.049-26.041,58.049-58.05
      c0-3.116-0.252-6.229-0.753-9.307C282.406,156.692,289.432,139.941,289.432,122.216z"/>
  </g></svg>`,
  },
  {
    name: 'onnistuneesti_ratkaistu_liikenneverkko',
    label: 'Onnistuneesti ratkaistu liikenneverkko',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 496 496"><g>
		<polygon points="119.178,72.985 0,423.015 60.237,423.015 146.667,72.985 		"/>
		<polygon points="376.822,72.985 349.333,72.985 435.763,423.015 496,423.015 		"/>
		<path d="M170.176,72.985L83.93,423.015h127.624l3.514-51.512h65.864l3.514,51.512H412.07L325.827,72.985H170.176z M236.651,76.998
			h22.699l3.596,49.085h-29.893L236.651,76.998z M229.458,175.167h37.086l3.597,49.084h-44.283L229.458,175.167z M218.667,322.417
			l3.596-49.082h51.475l3.599,49.082H218.667z"/>
	</g></svg>`,
  },
  {
    name: 'inhimillinen_mittakaava',
    label: 'Inhimillinen mittakaava',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 124.498 124.498"><g>
		<circle cx="41.686" cy="29.656" r="8.472"/>
		<circle cx="10.637" cy="58.798" r="5.414"/>
		<circle cx="82.811" cy="29.656" r="8.472"/>
		<path d="M119.807,67.073c-0.082-0.047-0.168-0.08-0.254-0.111c-0.902-0.537-3.451-2.228-4.371-2.447
			c-0.004-0.001-0.011-0.002-0.015-0.004l-1.308,1.373l-1.348-1.357c-0.539,0.133-6.963,3.893-9.556,1.631
			c0.813-0.947,1.054-2.318,0.494-3.525c-4.772-10.336-8.542-18.5-14.97-22.441c-0.168-0.104-0.344-0.183-0.521-0.252
			c-0.943-0.623-2.003-1.079-3.083-1.338c-0.006-0.001-0.015-0.002-0.021-0.004l-2.049,2.149l-2.109-2.125
			c-0.84,0.206-3.1,1.321-3.389,1.498c-0.346,0.211-0.687,0.425-1.023,0.644c-0.863,0.459-8.604,4.893-14.007,18.501
			c-5.251-13.198-12.699-17.752-13.906-18.42c-1.032-0.667-1.972-1.22-2.133-1.261c-0.771-0.431-1.601-0.757-2.441-0.962
			l-2.111,2.125l-2.046-2.149c-0.008,0.002-0.016,0.002-0.021,0.004c-1.08,0.259-2.139,0.715-3.084,1.338
			c-0.179,0.07-0.354,0.148-0.522,0.252c-6.426,3.942-10.197,12.105-14.969,22.441c-0.56,1.207-0.319,2.576,0.494,3.523
			c-2.593,2.262-9.017-1.498-9.555-1.63l-1.348,1.358l-1.309-1.375c-0.004,0.002-0.009,0.004-0.013,0.005
			c-0.92,0.22-3.47,1.909-4.372,2.446c-0.086,0.033-0.172,0.065-0.255,0.111C4.497,67.181,0,69.833,0,77.599
			c0,1.062,0.861,1.925,1.924,1.925c1.064,0,1.926-0.862,1.926-1.925c0-2.566,0.601-4.297,1.243-5.42v2.732L2.974,87.03h2.398
			l0.002,13.799c0,1.373,1.112,2.485,2.483,2.484c1.372,0,2.484-1.111,2.484-2.484L10.339,87.03h0.354v13.799
			c0,1.373,1.112,2.484,2.482,2.484c1.375,0,2.485-1.111,2.485-2.484l0.002-13.799h2.749l-2.233-12.154V71.31
			c0.777,0.285,1.606,0.466,2.488,0.466c1.843,0,3.928-0.79,6.331-3.085c0.508-0.484,0.715-1.163,0.623-1.809
			c0.592-0.327,1.092-0.83,1.396-1.491c2.131-4.614,4.042-8.746,6-12.098v11.394c0,0.885,0.173,1.71,0.472,2.471
			c-0.021,0.17-0.038,0.342-0.038,0.52l0.004,31.496c0,2.148,1.739,3.888,3.886,3.887c2.147,0,3.888-1.74,3.888-3.887l-0.002-27.03
			c0.153,0.007,0.308,0.021,0.462,0.021c0.03,0,0.061-0.004,0.089-0.004v27.014c0,2.146,1.741,3.887,3.888,3.887
			c0.002,0,0.002,0,0.002,0c2.145,0,3.886-1.74,3.886-3.887l0.002-31.303c0.51-0.943,0.806-2.012,0.806-3.184V52.744
			c0.016,0.043,0.01-0.418,0.006-1.179c2.024,2.554,4.323,6.285,6.257,11.593c0.494,1.354,1.773,2.195,3.137,2.195
			c0.378,0,0.766-0.064,1.143-0.203c0.568-0.207,1.036-0.562,1.398-0.995c0.359,0.417,0.816,0.759,1.371,0.962
			c0.376,0.137,0.763,0.202,1.144,0.202c1.361,0,2.641-0.841,3.135-2.196c1.814-4.981,3.962-8.581,5.904-11.122
			c0.115,0.292,0.197,0.6,0.225,0.925c0.021-0.06,0.04-0.125,0.061-0.184v7.136l-4.346,28.366c1.626,0.807,3.369,1.366,5.154,1.737
			v9.188c0,2.146,1.738,3.887,3.886,3.887c0,0,0,0,0.002,0c2.146,0,3.886-1.74,3.886-3.887v-8.594
			c0.187-0.007,0.368-0.016,0.553-0.023l-0.002,8.617c0,2.146,1.74,3.887,3.889,3.887c2.146,0.001,3.886-1.739,3.886-3.887
			l0.003-9.613c3.084-0.631,5.109-1.312,5.109-1.312l-4.676-29.447V53.29c1.959,3.352,3.869,7.484,6,12.098
			c0.305,0.66,0.805,1.164,1.396,1.49c-0.091,0.646,0.116,1.324,0.624,1.81c2.402,2.295,4.488,3.085,6.33,3.085
			c0.882,0,1.711-0.182,2.488-0.466v3.567l-2.233,12.152h2.749v13.801c0,1.371,1.112,2.483,2.484,2.483
			c1.373,0,2.484-1.112,2.484-2.483V87.026h0.354l-0.002,13.801c0,1.371,1.11,2.483,2.483,2.483c1.371,0,2.482-1.112,2.482-2.483
			l0.002-13.801h2.398l-2.121-12.119v-2.732c0.643,1.125,1.244,2.854,1.244,5.421c0,1.063,0.861,1.925,1.926,1.925
			c1.062,0,1.924-0.861,1.924-1.925C124.494,69.833,119.998,67.182,119.807,67.073z"/>
		<circle cx="113.859" cy="58.798" r="5.414"/>
	</g></svg>`,
  },
  {
    name: 'saattoliikenne_hyvin_ratkaistu',
    label: 'Saattoliikenne hyvin ratkaistu',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 512 512"><path fill="#000" d="M174 20.85L148.7 74.7l-57-46.74 26.9 66.24-60.9-22.36 46.2 49.36L39 149l96 10.1V103h85.6l15.6-82.15-48.1 54.2-14.1-54.2zm101.8.04L291.4 103H377v56.1l96-10.1-64.9-27.8 46.1-49.32-60.8 22.36L420.3 28l-57 46.74L338 20.89l-14.1 54.2-48.1-54.2zM153 121v39c-4.3.6-8.3 1.2-11.8 1.9-4.1.8-7.7 1.7-10.8 2.8-3.2 1.1-5.9 2.1-8.8 4.9l-1.5 1.5-27.18 81.6c-12.7-12.8-26.02-17.4-37.3-17.3-29.47.2-45.11 32.7-.06 36.3 3.16-2.5 6.52-4.8 10.11-6.9 12.96-7.7 28.69-13 47.43-15.7l22.4-67c.3-.2.4-.3.8-.4 1.9-.7 4.8-1.4 8.4-2.1 7.1-1.4 17-2.6 28.6-3.6 23.1-2 52.9-3 82.7-3 29.8 0 59.6 1 82.7 3 11.6 1 21.5 2.2 28.6 3.6 3.6.7 6.5 1.4 8.4 2.1.4.1.5.2.8.4l22.4 67c18.7 2.7 34.4 8 47.4 15.7 3.6 2.1 7 4.4 10.1 6.9 45.1-3.6 29.5-36.1 0-36.3-11.3-.1-24.6 4.5-37.3 17.3l-27.2-81.6-1.5-1.5c-2.9-2.8-5.6-3.8-8.8-4.9-3.1-1.1-6.7-2-10.8-2.8-3.5-.7-7.5-1.3-11.8-1.9v-39h-62v34.6c-5.9-.1-11.9-.3-18-.4V121h-46v34.2c-6.1.1-12.1.3-18 .4V121h-62zm-9 144c-30.9 0-53.18 5.8-69.17 15.2-3.35 2-6.43 4.2-9.29 6.5L178.1 343h155.8l112.6-56.3c-2.9-2.3-5.9-4.5-9.3-6.5-16-9.4-38.3-15.2-69.2-15.2H144zm-91.46 35.4c-4.14 5.7-7.47 12-10.15 18.9-12.13 31.2-9.69 74.8-2.67 119.7h99.48l27.8-41.7v-39.7L52.54 300.4zm406.96 0L345 357.6v39.7l27.8 41.7h99.5c7-44.9 9.4-88.5-2.7-119.7-2.7-6.9-6-13.2-10.1-18.9zM64 336l64 16v32H48.1L64 336zm384 0l16 48h-80v-32l64-16zm-263 25v30h142v-30H185zM64.1 407H128v18H64.1v-18zm319.9 0h64v18h-64v-18zm-203.2 2l-20 30h190.4l-20-30H180.8zM41 457v30h62v-30H41zm368 0v30h62v-30h-62z"/></svg>`,
  },
  {
    name: 'asemakeskushanke_huomioitu',
    label: 'Asemakeskushanke huomioitu',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 412.795 412.795"><g>
    <path d="M319.057,194.575v-15.938h12.484V146.64l-121.814-43.727V78.055c11.607,3.979,20.348-8.847,32.527-1.511
      c0-9.043,0-13.566,0-22.607c-12.18-7.334-20.92,5.49-32.527,1.511v-4.05h-6.459v51.444L81.254,146.64v31.998h12.484v15.938H0
      v23.162h14.592v132.522h63.607v11.139h256.398v-11.139h63.604V217.737h14.594v-23.162H319.057z M70.188,318.108H41.129v-82.476
      h29.059V318.108z M154.266,301.616h-31.623v-34.771h31.623V301.616z M154.266,246.735h-31.623v-34.77h31.623V246.735z
       M226.4,339.118h-40.006v-75.006H226.4V339.118z M190.588,246.735v-34.77h31.619v34.77H190.588z M230.004,193.04
      c0,0-15.059,9.994-23.605,9.994c-8.547,0-23.606-9.994-23.606-9.994v-54.105c0,0,8.578,3.328,23.606,3.328
      c15.023,0,23.605-3.328,23.605-3.328V193.04z M290.152,301.616h-31.623v-34.771h31.623V301.616z M290.152,246.735h-31.623v-34.77
      h31.623V246.735z M371.666,318.108h-29.057v-82.476h29.057V318.108z"/>
    <path d="M204.063,151.001c0,0.771,0.379,1.451,0.955,1.877l-4.459,6.701l-8.202,0.523c-0.078-1.219-1.081-2.189-2.321-2.189
      c-1.287,0-2.334,1.049-2.334,2.338c0,1.285,1.047,2.332,2.334,2.332c0.373,0,0.72-0.096,1.032-0.25l3.651,7.361l-3.663,7.388
      c-0.31-0.151-0.653-0.243-1.021-0.243c-1.287,0-2.334,1.045-2.334,2.334c0,1.287,1.047,2.332,2.334,2.332
      c1.252,0,2.264-0.984,2.324-2.217l8.199,0.521l4.46,6.703c-0.577,0.426-0.956,1.104-0.956,1.875c0,1.289,1.047,2.334,2.336,2.334
      c1.287,0,2.334-1.045,2.334-2.334c0-0.77-0.379-1.449-0.954-1.875l4.46-6.703l8.199-0.521c0.061,1.232,1.072,2.217,2.324,2.217
      c1.285,0,2.334-1.045,2.334-2.332c0-1.289-1.049-2.334-2.334-2.334c-0.368,0-0.711,0.093-1.021,0.244l-3.665-7.389l3.652-7.361
      c0.313,0.154,0.66,0.25,1.033,0.25c1.285,0,2.334-1.047,2.334-2.332c0-1.289-1.049-2.338-2.334-2.338
      c-1.24,0-2.243,0.971-2.321,2.189l-8.202-0.523l-4.459-6.703c0.575-0.426,0.953-1.104,0.953-1.875c0-1.291-1.047-2.334-2.334-2.334
      C205.109,148.667,204.063,149.71,204.063,151.001z M214.018,169.694c0,4.209-3.41,7.619-7.619,7.619
      c-4.207,0-7.619-3.41-7.619-7.619s3.412-7.619,7.619-7.619C210.607,162.075,214.018,165.485,214.018,169.694z"/>
  </g></svg>`,
  },
  {
    name: 'miellyttävä_pienilmasto',
    label: 'Miellyttävä pienilmasto (valoisuus, varjoisuus)',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 216.182 216.182"><g>
    <path d="M199.151,18.92C196.486,8.071,186.677,0,175.018,0c-8.206,0-15.726,4.042-20.302,10.522
      c-0.429-0.028-0.859-0.042-1.292-0.042c-10.811,0-19.606,8.796-19.606,19.607s8.796,19.607,19.606,19.607h43.024
      c8.55,0,15.506-6.956,15.506-15.505C211.954,26.562,206.417,20.203,199.151,18.92z"/>
    <path d="M189.88,201.182h-58.352v-14.106c32.529-3.734,57.879-31.423,57.879-64.936c0-36.05-29.329-65.379-65.379-65.379
      c-14.068,0-27.354,4.387-38.438,12.502L67.703,13.294c-0.993-3.108-3.881-5.217-7.144-5.217s-6.151,2.109-7.144,5.217
      L4.584,166.083c-0.729,2.281-0.325,4.772,1.087,6.706c1.412,1.934,3.663,3.077,6.057,3.077h41.331v25.315H29.746
      c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5H189.88c4.143,0,7.5-3.358,7.5-7.5S194.023,201.182,189.88,201.182z M68.059,175.867
      h18.716c8.911,6.2,19.047,10.01,29.753,11.223v14.092h-48.47V175.867z"/>
  </g></svg>`,
  },
  {
    name: 'teknistaloudellisesti_toteuttamiskelpoinen',
    label: 'Teknistaloudellisesti toteuttamiskelpoinen',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 489.003 489.003"><g>
    <path d="M305.802,156.814c-33.8-19.5-88.4-19.5-122,0s-33.4,51.2,0.4,70.7s88.4,19.5,122,0
      C339.802,207.914,339.602,176.314,305.802,156.814z M290.302,187.514c-2.9,0.9-5.8,1.9-8.7,2.8c-1.8,0.5-2.9,0.6-3.7,0.2
      c-0.4-0.3-0.8-0.7-1.2-1.3c-1.9-3.1-4.8-5.8-8.7-8c-0.5-0.3-1.1-0.6-1.7-0.9c-1.3-0.7-2.5-1.2-4.1-1.6c-5.6-1.3-10.6,0.8-9.9,4.3
      c0.3,1.8,1.3,3.4,2.5,5.1c2,2.8,4.2,5.6,5.6,8.6c4.7,9.4-5.5,18.7-21.9,19.6c-5.9,0.3-11.5-0.4-16.7-2.1c-2.3-0.7-4-0.7-5.7,0.5
      c-1.7,1.1-3.6,2.1-5.4,3.1c-1.6,0.9-3.3,1-4.9,0.1c-1.2-0.6-2.3-1.3-3.5-1.9c-0.8-0.5-1.6-0.9-2.4-1.4c-1.7-1-1.5-2,0.1-3
      c1.3-0.8,2.6-1.5,3.8-2.3c2.9-1.7,2.9-1.8,0.5-3.7c-3-2.4-5.7-4.9-7.4-7.7c-1.3-2.2-1-2.7,2.5-3.9c2.6-0.8,5.1-1.7,7.7-2.5
      c1.9-0.6,3-0.7,3.8-0.3c0.5,0.3,0.8,0.7,1.2,1.4c1.7,3.2,4.6,6,8.1,8.7c0.6,0.5,1.3,0.9,1.9,1.3c1.9,1.1,4.1,1.9,6.6,2.5
      c6.5,1.5,12.3-1.1,11.7-5.2c-0.2-1.4-0.9-2.6-1.8-3.9c-2.2-3.3-5.1-6.4-6.6-9.9c-2.4-5.6-1.3-10.7,6.4-14.7c8.8-4.5,18.6-4.8,29-2
      c4.3,1.2,4.2,1.2,7.5-0.7c1.1-0.7,2.2-1.3,3.3-1.9c2.5-1.4,3.4-1.4,5.9,0c0.8,0.4,1.5,0.9,2.3,1.3c5.3,3,5.3,3,0.1,6.1
      c-3.7,2.1-3.7,2.1-0.6,4.6c2.4,1.9,4.3,3.9,5.7,6.1C292.702,186.014,292.302,186.914,290.302,187.514z M350.902,253.314
      c-9.3,5.4-24.4,5.4-33.8,0c-9.3-5.4-9.4-14.2-0.1-19.6c9.3-5.4,24.4-5.4,33.8,0C360.202,239.114,360.302,247.914,350.902,253.314z
       M172.902,150.514c-9.3,5.4-24.4,5.4-33.8,0c-9.4-5.4-9.4-14.2-0.1-19.6c9.3-5.4,24.4-5.4,33.8,0
      C182.102,136.314,182.202,145.114,172.902,150.514z M477.402,211.414l-266.5-153.9c-15.4-8.9-40.4-8.9-55.7,0l-142.9,83
      c-15.3,8.9-15.2,23.4,0.2,32.3l266.5,153.9c15.4,8.9,40.4,8.9,55.7,0l142.8-83C492.902,234.814,492.802,220.314,477.402,211.414z
       M337.602,297.414c-1.7-1.6-3.7-3.1-6.1-4.5c-15.6-9-40.9-9-56.4,0c-1.2,0.7-2.2,1.4-3.3,2.2l-206.9-119.5c2-0.8,3.9-1.7,5.7-2.7
      c15.5-9,15.4-23.6-0.2-32.6c-1.7-1-3.5-1.9-5.4-2.6l85.3-49.6c1.3,1.1,2.8,2.1,4.5,3.1c15.6,9,40.9,9,56.4,0c1.8-1,3.3-2.1,4.7-3.3
      l207.6,119.8c-2.8,1-5.3,2.1-7.7,3.5c-15.5,9-15.5,23.7,0.2,32.7c2.4,1.4,5.1,2.5,7.9,3.5L337.602,297.414z M5.502,203.614
      c6.8-3.5,17.3-3,23.8,0.8l278.6,160.8l150.6-87.6c6.5-3.8,17.2-3.8,23.8,0c6.6,3.8,6.6,10,0.1,13.8l-160.1,93
      c-7.8,4.6-20.6,4.6-28.5,0l-5.6-3.2l-3.9-2.3l-279.3-161.2C-1.798,213.814-1.698,207.314,5.502,203.614z M482.602,341.714
      l-160.1,93c-7.8,4.6-20.6,4.6-28.5,0l-5.5-3.2l-4-2.3l-279.3-161.2c-6.8-3.9-6.6-10.4,0.6-14.1c6.7-3.5,17.3-3,23.8,0.8
      l278.5,160.8l150.6-87.5c6.6-3.8,17.2-3.8,23.8,0C489.102,331.714,489.202,337.914,482.602,341.714z"/>
  </g></svg>`,
  },
];

export const multi_lines_rating_fields = [
  {
    label: 'Overall rating',
    svg: `<svg x={x - 10} y={y + 8} width={30} height={30} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#353C43"
        fillRule="nonzero"
        d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"
      />
      <path d="M-2-2.5h20v20H-2z" />
    </g>
  </svg>`,
  },
  {
    label: 'Näkemyksellinen',
    svg: `<svg x={x - 10} y={y + 8} width={30} height={30} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#353C43"
        fillRule="nonzero"
        d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"
      />
      <path d="M-2-2.5h20v20H-2z" />
    </g>
  </svg>`,
  },
  {
    label: 'Vahva arkkitehtuuri',
    svg: `<svg x={x - 10} y={y + 8} width={30} height={30} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#353C43"
        fillRule="nonzero"
        d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"
      />
      <path d="M-2-2.5h20v20H-2z" />
    </g>
  </svg>`,
  },
  {
    label: 'Uusi ja vanha käsi kädessä',
    svg: `<svg x={x - 10} y={y + 8} width={30} height={30} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#353C43"
        fillRule="nonzero"
        d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"
      />
      <path d="M-2-2.5h20v20H-2z" />
    </g>
  </svg>`,
  },
  {
    label: 'Toimiva liityntäpysäköinti',
    svg: `<svg x={x - 10} y={y + 8} width={30} height={30} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#353C43"
        fillRule="nonzero"
        d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"
      />
      <path d="M-2-2.5h20v20H-2z" />
    </g>
  </svg>`,
  },
  {
    label: 'Laadukas kävely-ympäristö',
    svg: `<svg x={x - 10} y={y + 8} width={30} height={30} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#353C43"
        fillRule="nonzero"
        d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"
      />
      <path d="M-2-2.5h20v20H-2z" />
    </g>
  </svg>`,
  },
  {
    label: 'Sujuvat pyöräily-olosuhteet',
    svg: `<svg x={x - 10} y={y + 8} width={30} height={30} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#353C43"
        fillRule="nonzero"
        d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"
      />
      <path d="M-2-2.5h20v20H-2z" />
    </g>
  </svg>`,
  },
  {
    label: 'Oivalliset toiminnalliset ideat',
    svg: `<svg x={x - 10} y={y + 8} width={30} height={30} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#353C43"
        fillRule="nonzero"
        d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"
      />
      <path d="M-2-2.5h20v20H-2z" />
    </g>
  </svg>`,
  },
  {
    label: 'Hyvät kestävän kehityksen ratkaisut',
    svg: `<svg x={x - 10} y={y + 8} width={30} height={30} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#353C43"
        fillRule="nonzero"
        d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"
      />
      <path d="M-2-2.5h20v20H-2z" />
    </g>
  </svg>`,
  },
  {
    label: 'Monipuoliset asumisen ratkaisut',
    svg: `<svg x={x - 10} y={y + 8} width={30} height={30} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#353C43"
        fillRule="nonzero"
        d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"
      />
      <path d="M-2-2.5h20v20H-2z" />
    </g>
  </svg>`,
  },
  {
    label: 'Hieno viherympäristö',
    svg: `<svg x={x - 10} y={y + 8} width={30} height={30} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#353C43"
        fillRule="nonzero"
        d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"
      />
      <path d="M-2-2.5h20v20H-2z" />
    </g>
  </svg>`,
  },
  {
    label: 'Onnistuneesti ratkaistu liikenneverkko',
    svg: `<svg x={x - 10} y={y + 8} width={30} height={30} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#353C43"
        fillRule="nonzero"
        d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"
      />
      <path d="M-2-2.5h20v20H-2z" />
    </g>
  </svg>`,
  },
];

export const rating_fields_3 = {
  overall: {
    label: 'Overall rating',
    svg:
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 15"><g fill="none" fill-rule="evenodd"><path fill="#353C43" fill-rule="nonzero" d="M13.833 0H2.167C1.25 0 .5.75.5 1.667v11.666C.5 14.25 1.25 15 2.167 15h11.666c.917 0 1.667-.75 1.667-1.667V1.667C15.5.75 14.75 0 13.833 0zM5.5 11.667H3.833V5.833H5.5v5.834zm3.333 0H7.167V3.333h1.666v8.334zm3.334 0H10.5V8.333h1.667v3.334z"/><path d="M-2-2.5h20v20H-2z"/></g></svg>',
  },

  trafic_transport: {
    label: 'Criteria 1',
    svg:
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 17"><g fill="none" fill-rule="evenodd"><path fill="#353C43" fill-rule="nonzero" d="M11.833 12.617V5.583c0-2.325-2.175-2.833-5.008-2.908l.633-1.258h2.709V.167H1.833v1.25h3.959l-.634 1.266c-2.608.075-4.991.592-4.991 2.9v7.034c0 1.208.991 2.216 2.158 2.475L1 16.417v.416h1.858l1.667-1.666h3.142l1.666 1.666H11v-.416l-1.25-1.25h-.067c1.409 0 2.15-1.142 2.15-2.55zM6 13.917c-.692 0-1.25-.559-1.25-1.25 0-.692.558-1.25 1.25-1.25s1.25.558 1.25 1.25c0 .691-.558 1.25-1.25 1.25zm4.167-3.75H1.833V6h8.334v4.167z"/><path d="M-4-1.5h20v20H-4z"/></g></svg>',
  },
  construction_architecture: {
    label: 'Criteria 2',
    svg:
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 21"><g fill="none" fill-rule="evenodd"><path  d="M0 .5h20v20H0z"/><path fill="#353C43" fill-rule="nonzero" d="M14.167 9.667V3H5.833v3.333H2.5V18h6.667v-3.333h1.666V18H17.5V9.667h-3.333zm-8.334 6.666H4.167v-1.666h1.666v1.666zm0-3.333H4.167v-1.667h1.666V13zm0-3.333H4.167V8h1.666v1.667zM9.167 13H7.5v-1.667h1.667V13zm0-3.333H7.5V8h1.667v1.667zm0-3.334H7.5V4.667h1.667v1.666zM12.5 13h-1.667v-1.667H12.5V13zm0-3.333h-1.667V8H12.5v1.667zm0-3.334h-1.667V4.667H12.5v1.666zm3.333 10h-1.666v-1.666h1.666v1.666zm0-3.333h-1.666v-1.667h1.666V13z"/></g></svg>',
  },
  urban_outdoor_green_areas: {
    label: 'Criteria 3',
    svg:
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 17"><g fill="none" fill-rule="evenodd"><path d="M-1-1.5h20v20H-1z"/><path fill="#353C43" fill-rule="nonzero" d="M17.475 6.142A5.83 5.83 0 0 0 11.642.308a5.83 5.83 0 0 0-5.834 5.834c0 2.891 2.1 5.283 4.859 5.741v3.284H4v-2.5h.833V9.333A.836.836 0 0 0 4 8.5H1.5a.836.836 0 0 0-.833.833v3.334H1.5v4.166h13.333v-1.666h-2.5v-3.234a5.833 5.833 0 0 0 5.142-5.791zM2.75 7.667c.692 0 1.25-.559 1.25-1.25 0-.692-.558-1.25-1.25-1.25s-1.25.558-1.25 1.25c0 .691.558 1.25 1.25 1.25z"/></g></svg>',
  },
  urban_culture_events_tourism: {
    label: 'Criteria 4',
    svg:
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 17"><g fill="none" fill-rule="evenodd"><path d="M-1-1.5h20v20H-1z"/><g fill="#353C43" fill-rule="nonzero"><path d="M17.333 6L9 .167.667 6h7.5v10.833h1.666V6z"/><path d="M2.45 8.5l-1.633.308.683 3.642v4.383h1.667l.016-3.333h1.65v3.333H6.5v-5H3.083zM14.917 11.833H11.5v5h1.667V13.5h1.65l.016 3.333H16.5V12.45l.683-3.642L15.55 8.5z"/></g></g></svg>',
  },
  housing_lifestyle: {
    label: 'Criteria 5',
    svg:
      '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 15"><g fill="none" fill-rule="evenodd"><path d="M-1-2.5h20v20H-1z"/><path fill="#353C43" fill-rule="nonzero" d="M14.833 5.25V.833h-2.5V3L9 0 .667 7.5h2.5v6.667h4.166v-5h3.334v5h4.166V7.5h2.5l-2.5-2.25zm-7.5.583c0-.916.75-1.666 1.667-1.666s1.667.75 1.667 1.666H7.333z"/></g></svg>',
  },
  business_industral_knowhow: {
    label: 'Criteria 6',
    svg:
      '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 15"><g fill="none" fill-rule="evenodd"><path d="M-1-2.5h20v20H-1z"/><path fill="#353C43" fill-rule="nonzero" d="M3.167 4.167h1.666v6.666H3.167V4.167zm5.833 0H6.5A.836.836 0 0 0 5.667 5v5c0 .458.375.833.833.833H9A.836.836 0 0 0 9.833 10V5A.836.836 0 0 0 9 4.167zm-.833 5h-.834V5.833h.834v3.334zm5.833-5h-2.5a.836.836 0 0 0-.833.833v5c0 .458.375.833.833.833H14a.836.836 0 0 0 .833-.833V5A.836.836 0 0 0 14 4.167zm-.833 5h-.834V5.833h.834v3.334z"/><path d="M2.333 2.5h13.334v10H2.333z"/><path fill="#353C43" fill-rule="nonzero" d="M.667.833v13.334h16.666V.833H.667zM2.333 12.5v-10h13.334v10H2.333z"/></g></svg>',
  },
};
